/**
 * Ryan O'Dowd
 * 2022-12-04
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors, globalScale}) => {
  return {
    container: {
      backgroundColor: 'transparent',
      elevation: 0,
    },
    gradient: {
      position: 'absolute',
      display: 'flex',
      borderRadius: 6,
    },
    disabled: {
      backgroundColor: `${colors.disabled}44`,
    },
    largeText: {
      fontSize: globalScale * 17,
    },
  };
};

export default getStyles;
